import { Outlet } from 'react-router-dom'
import { Navbar } from './Navbar'
import { useUser } from '@/contexts/UserContext'
import { useAuth } from '@/contexts/AuthContext'

export function AppShell() {
  const { user } = useUser()
  const { logout } = useAuth()

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Navbar
        user={user}
        onLogout={logout}
      />
      <main className="w-full max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <Outlet />
      </main>
    </div>
  )
}
